@if (wa?.image) {
<img [src]="getImageUrl()" alt="WhatsApp Image" style="width: 220px; height: auto" />
<button mat-icon-button (click)="openImageInNewWindow()" aria-label="Open image in new window">
	<mat-icon>open_in_new</mat-icon>
</button>

} @else {
<div>[{{ 'COMMUNICATIONS.WHATSAPP.not_supported_wa_message' | translate | capitalize }}]</div>

} @if (waLink) { {{ waLink }} }
